import type { ReactNode } from 'react'
import { StateLayout } from './StateLayout'
import { LockIcon } from '../icons'
import type { StateScale } from './EmptyState'

export interface ForbiddenStateProps {
  readonly sentence?: string | undefined
  readonly action: ReactNode
  readonly requestId?: string | null | undefined
  readonly scale: StateScale
  readonly className?: string | undefined
}

export function ForbiddenState({
  sentence = 'You do not have access to this part of the workspace.',
  action,
  requestId,
  scale,
  className,
}: ForbiddenStateProps) {
  return (
    <div role="alert" data-testid="forbidden-state" data-scale={scale}>
      <StateLayout scale={scale} className={className}>
        <div className="flex items-center gap-2 text-muted-foreground">
          <LockIcon />
          <h2
            className={
              scale === 'embedded'
                ? 'text-sm font-medium text-foreground'
                : 'font-heading text-xl font-semibold text-foreground'
            }
          >
            Not available to you
          </h2>
        </div>
        <p className="text-sm text-muted-foreground">{sentence}</p>
        {action}
        {requestId ? (
          <p className="text-xs text-muted-foreground">
            Request id <span className="font-mono text-foreground select-all">{requestId}</span>
          </p>
        ) : null}
      </StateLayout>
    </div>
  )
}
